module.exports = __webpack_public_path__ + "static/media/elbow1.d477beae.png";